import * as THREE from "three";
import React, { useRef, Suspense } from "react";
import { Canvas, extend, useFrame, useLoader } from "@react-three/fiber";
import { shaderMaterial } from "@react-three/drei";
import glsl from "babel-plugin-glsl/macro";
import { AiOutlineLink } from "react-icons/ai";

const WaveShaderMaterial = shaderMaterial(
  // Uniform
  {
    uTime: 0,
    uColor: new THREE.Color(0.0, 0.0, 0.0),
    uTexture: new THREE.Texture(),
  },
  // Vertex Shader
  glsl`
    precision mediump float;
    varying vec2 vUv;
    varying float vWave;
    uniform float uTime;
    #pragma glslify: snoise3 = require(glsl-noise/simplex/3d);
    void main() {
      vUv = uv;
      vec3 pos = position;
      float noiseFreq = 2.5;
      float noiseAmp = 0.20;
      vec3 noisePos = vec3(pos.x * noiseFreq + uTime, pos.y, pos.z);
      pos.z += snoise3(noisePos) * noiseAmp;
      vWave = pos.z;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);  
    }
  `,
  // Fragment Shader
  glsl`
    precision mediump float;
    uniform vec3 uColor;
    uniform float uTime;
    uniform sampler2D uTexture;
    varying vec2 vUv;
    varying float vWave;
    void main() {
      float wave = vWave * 0.2;
      vec3 texture = texture2D(uTexture, vUv + wave).rgb;
      gl_FragColor = vec4(texture, 1.0); 
    }
  `
);

extend({ WaveShaderMaterial });

const Wave = ({ imageURL }) => {
  const ref = useRef();
  useFrame(({ clock }) => (ref.current.uTime = clock.getElapsedTime()));

  const [image] = useLoader(THREE.TextureLoader, [imageURL]);

  return (
    <mesh>
      <planeBufferGeometry args={[0.8, 0.6, 12, 12]} />
      <waveShaderMaterial uColor={"hotpink"} ref={ref} uTexture={image} />
    </mesh>
  );
};

const Scene = ({ imageURL }) => {
  return (
    <Canvas
      // style={{ width: `100%`, height: `50%` }}
      camera={{ fov: 6, position: [0, 0, 5] }}
    >
      <Suspense fallback={null}>
        <Wave imageURL={imageURL} />
      </Suspense>
    </Canvas>
  );
};

const SingleProject = ({
  projectName,
  details,
  tools,
  flexDirection,
  imageURL,
  linkToProject,
}) => {
  return (
    <div className="projects_inner" style={{ flexDirection: flexDirection }}>
      <div className="projects_left">
        <h3>{projectName}</h3>
        <h4>Details</h4>
        <p>{details}</p>
        <h4>Tools Used</h4>
        <p>{tools}</p>
        <h4>
          <a
            className="project-link"
            href={linkToProject}
            target="_blank"
            rel="noreferrer"
          >
            Link <AiOutlineLink />
          </a>
        </h4>
      </div>
      <div className="projects_right">
        <Scene imageURL={imageURL} />
      </div>
    </div>
  );
};

export default SingleProject;
